var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShoppingBag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.55104 12.6604L2.85541 10.9342C3.21514 8.89405 3.395 7.87395 4.10729 7.26998C4.81958 6.66602 5.84276 6.66602 7.88913 6.66602H12.1102C14.1566 6.66602 15.1798 6.66602 15.8921 7.26998C16.6043 7.87395 16.7842 8.89405 17.1439 10.9342L17.4483 12.6604C17.9461 15.4836 18.195 16.8952 17.4286 17.8223C16.6621 18.7493 15.2463 18.7493 12.4146 18.7493H7.58476C4.75306 18.7493 3.3372 18.7493 2.57078 17.8223C1.80436 16.8952 2.05325 15.4836 2.55104 12.6604Z",
    stroke: "#242428",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 6.66602L6.38985 4.98783C6.54631 3.11024 8.11589 1.66602 10 1.66602C11.8841 1.66602 13.4537 3.11024 13.6102 4.98783L13.75 6.66602",
    stroke: "#242428",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.16667C12.3916 10.3442 11.3047 11.25 10 11.25C8.69527 11.25 7.60835 10.3442 7.5 9.16667",
    stroke: "#242428",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShoppingBag);
export default __webpack_public_path__ + "static/media/icon-shopping-bag.09c45f46e492ac6c8e84455838ef86c5.svg";
export { ForwardRef as ReactComponent };